const Grid = ({ children }) => {
    return (
        <table className="main-list--grid-view main-list__table-wrapper">
            {children}
        </table>
    );
};

export default Grid;
